import Client from '@/repositories/Clients/AxiosClient'
import Config from '@/repositories/Clients/AxiosDefaultConfig'

const resource = `${Config.basePath}/shortcut-button-for-plugin`

export default {
  // payload: {
  //   labelTitle: object, {en, zh, km, vi}
  //   labelIcon: string (text/emoji or image URL)
  //   labelMessage: object, {en, zh, km, vi}
  //   messageResponse: object, {en, zh, km, vi}
  // }
  create: payload => Client.post(`${resource}/create`, payload),
  update: (id, payload) => Client.put(`${resource}/update/${id}`, payload),
  delete: id => Client.delete(`${resource}/delete/${id}`, { noCamelizeKey: true }),
  // payload: {
  //   page: number,
  //   limit: number,
  // }
  list: payload => Client.get(`${resource}/`, {
    params: payload,
  }),
  // payload: [
  //     {
  //         "id": "68f71179e405795821915553",
  //         "sorting": 2
  //     },
  //     {
  //         "id": "68f7117de4057958219155a2",
  //         "sorting": 3
  //     }
  //  ]
  reorder: payload => Client.put(`${resource}/reorder`, payload),
}
